import { render, staticRenderFns } from "./CertificateInfo.vue?vue&type=template&id=bc6426e2&scoped=true"
import script from "./CertificateInfo.vue?vue&type=script&lang=js"
export * from "./CertificateInfo.vue?vue&type=script&lang=js"
import style0 from "./CertificateInfo.vue?vue&type=style&index=0&id=bc6426e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6426e2",
  null
  
)

export default component.exports